import React from 'react';
import SearchHighlightSegment from '../../../SearchHighlightSegment';

const HighlightDescription = ({ searchData }) => {
  if (!searchData) return null;
  const { highlights } = searchData;
  const descriptionHighlight = highlights.find((h) => h.field === 'description');
  if (descriptionHighlight) {
    return (
      <div className="highlight-description">
        <strong className="black">{'About: '}</strong>
        <SearchHighlightSegment htmlContent={descriptionHighlight.segments[0]} />
      </div>
    );
  }
  return null;
};

export default HighlightDescription;
